import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Picture from '../../../common/Picture';
import { PICTURE_VARIANTS as SIZES } from '../../../common/constants';
import { setParentChallenge } from '../actions';
import ProgressBar from '../../../common/ProgressBar';
import './styles.scss';
import { noop } from '../../../common/propTypes';

function ConnectedChallenge({
    id,
    // parentChallenge,
    thumbnail,
    startDate,
    endDate,
    title,
    progress,
    pickups,
    target,
    //    setParentChallenge,
}) {
    return (
        <div id={id} className="connectedChallengeCard">
            <div className="listGroup flex-column">
                <div className="row">
                    <div className="challengesCardAvatar grid">
                        <Picture
                            variant={SIZES.VARIANT_XL}
                            source={thumbnail}
                        />
                    </div>
                    <div className="challengesCardContent grid">
                        <div className="card-header">
                            <Link
                                to={`/challenges/${id}`}
                                // onClick={() =>
                                //     setParentChallenge(parentChallenge)
                                // }
                            >
                                <h2>
                                    {title.length > 70
                                        ? title.slice(0, 70)
                                        : title}
                                </h2>
                                <small>{`${startDate} - ${endDate}`}</small>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="align-self-end w-100 mt-2">
                        <h3 className="progress-text">
                            {`Pickups ${pickups}`}
                            <span>{`/${target}`}</span>
                        </h3>
                        <ProgressBar progress={progress} />
                    </div>
                </div>
            </div>
        </div>
    );
}

ConnectedChallenge.propTypes = {
    id: PropTypes.string,
    parentChallenge: PropTypes.object,
    thumbnail: PropTypes.string,
    title: PropTypes.string,
    pickups: PropTypes.number,
    target: PropTypes.number,
    progress: PropTypes.number,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    setParentChallenge: PropTypes.func,
};

ConnectedChallenge.defaultProps = {
    id: null,
    parentChallenge: null,
    thumbnail: null,
    title: null,
    pickups: 0,
    target: 0,
    progress: 0,
    startDate: '',
    endDate: '',
    setParentChallenge: noop,
};

const mapDispatchToProps = (dispatch) => {
    return {
        setParentChallenge: (challenge) =>
            dispatch(setParentChallenge(challenge)),
    };
};

export default connect(null, mapDispatchToProps)(ConnectedChallenge);
